import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type Cart } from '../../../../../../src/types/Cart';

const cartPath = (id: number) => {
  return `/api/v2/customers/${id}/cart/`;
};

interface Args {
  params: {
    id: number;
  };
  headers?: RequestHeaders;
}

interface RequestHeaders {
  saladShooterStreamId?: string;
}

export async function getCart(args: Args) {
  const { params, headers = {} } = args;
  const { id } = params;

  const headersObject: HeadersInit = {
    AUTHORIZATION: AUTHORIZATION_HEADER,
  };

  if (headers.saladShooterStreamId) {
    headersObject['X-SaladShooter-Stream-ID'] = headers.saladShooterStreamId;
  }

  return send<Cart>({
    method: 'GET',
    path: cartPath(id),
    headers: new Headers(headersObject),
  });
}
